import React from 'react';

import cx from 'classnames';
import { UseFormReturn } from 'react-hook-form';

import { HookInput } from 'components/shared/HookFormComponents';
import MapBlock from 'components/shared/MapBlock';
import Text from 'components/shared/Typography/Text';
import { debounce } from 'utils/debounce';
import { parseLatLngFromString } from 'utils/maps';

import sharedStyles from '../../../../shared/index.module.css';
import s from './index.module.css';
import { useGoogleMaps } from './useGoogleMaps';

type GoogleMapsAdapterFieldValues = {
  coords?: string;
  address?: string;
};

function GoogleMapsAdapter<T extends GoogleMapsAdapterFieldValues>({ control, watch, setValue }: UseFormReturn<T>) {
  const setCoords = (value: string) => {
    // @ts-ignore
    setValue('coords', value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };
  const setAddress = (value: string) => {
    // @ts-ignore
    setValue('address', value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const { handleChangeAddress, handleChangeCoords, handleClickMap } = useGoogleMaps({
    onChangeCoords: setCoords,
    onChangeAddress: setAddress,
  });

  const debHandleChangeAddress = debounce((value: string) => handleChangeAddress(value), 500);

  const onChangeAddress = (address: string) => {
    setAddress(address);
    debHandleChangeAddress(address);
  };

  const onChangeCoords = (coords: string) => {
    setCoords(coords);
    handleChangeCoords(coords);
  };

  // @ts-ignore
  const fieldCoords = watch('coords');
  const coords = React.useMemo(() => {
    return parseLatLngFromString(fieldCoords);
  }, [fieldCoords]);

  return (
    <>
      <div className={sharedStyles.headlineContainer}>
        <Text className={cx(sharedStyles.cssHeadline, sharedStyles.titleContainer)} type="brandon" isStrong>
          Location*
        </Text>
        <Text type="brandon" className={sharedStyles.descriptionText}>
          Search in Google Maps or add the GPS coordinates below to drop a pin.
        </Text>
      </div>

      <div className={sharedStyles.adapterContainer}>
        <HookInput
          name="address"
          // @ts-ignore // TODO: fix with refactoring of the HookInput
          control={control}
          onChange={onChangeAddress}
          label="Enter Property Name or Address*"
        />
      </div>

      <div className={sharedStyles.rowHeaderContainer}>
        <Text className={cx(s.textSpace, sharedStyles.cssHeadline)} type="brandon" isStrong>
          OR
        </Text>
        <Text className={sharedStyles.cssHeadline} type="brandon">
          GPS Coordinates*
        </Text>
      </div>

      <div className={sharedStyles.adapterContainer}>
        <HookInput
          name="coords"
          // @ts-ignore // TODO: fix with refactoring of the HookInput
          control={control}
          onChange={onChangeCoords}
          label="-14.235004, -51.92528*"
        />
      </div>

      <div>
        <MapBlock coords={coords} onClickMap={handleClickMap} />
      </div>
    </>
  );
}

export { GoogleMapsAdapter };
